import React from 'react';
import { FormControl, FormLabel, Select, Switch } from '@chakra-ui/react';

const UserTargeting = ({ formik }) => {
  return (
    <>
      <FormControl>
        <FormLabel>User Type</FormLabel>
        <Select
          name="actionProps.usersTargeting.userType"
          value={formik.values.actionProps.usersTargeting.userType}
          onChange={formik.handleChange}
        >
          <option value="all">All</option>
          <option value="returning">Returning</option>
          <option value="new">New</option>
        </Select>
      </FormControl>
      <FormControl>
        <FormLabel>Show to Mapped Users</FormLabel>
        <Switch
          name="actionProps.usersTargeting.showToMappedUsers"
          isChecked={formik.values.actionProps.usersTargeting.showToMappedUsers}
          onChange={formik.handleChange}
        />
      </FormControl>
    </>
  );
};

export default UserTargeting;